import { formatDistanceToNow, Locale } from "date-fns";
import type { Language } from "../language/language";
import { nl, fr, enGB as en, nb as no, it, de, es, ptBR } from "date-fns/locale";
import { assertUnreachable } from "../assertions/assertUnreachable";

export const dateFns_getLocaleFromLanguage = (language: Language): Locale => {
    switch (language) {
        case "nl":
            return nl;
        case "fr":
            return fr;
        case "en":
            return en;
        case "no":
            return no;
        case "it":
            return it;
        case "de":
            return de;
        case "es":
            return es;
        case "pt-br":
            return ptBR;
        default:
            return assertUnreachable(language);
    }
};

export const distanceToNow = (date: Date, language: Language): string | null => {
    const locale = dateFns_getLocaleFromLanguage(language);

    try {
        return formatDistanceToNow(date, { locale: locale });
    } catch (e) {
        console.error(`Could not create distanceToNow for date ${date}`);
        return null;
    }
};
